// extracted by mini-css-extract-plugin
export default {"ideas":"ideas_ideas__hsc1Y","containerLoader":"ideas_containerLoader__LCk9U","bottom":"ideas_bottom__fIH7I"};